import { types, getParent, flow } from 'mobx-state-tree';

const BASE_URL = 'business-policy/v1/settings';

const InternationalList = types.model('InternationalList', {
  OtherInternational: types.optional(types.string, ''),
  StandardInternational: types.optional(types.string, ''),
  ExpeditedInternational: types.optional(types.string, ''),
});

const DomesticList = types.model('DomesticList', {
  Other: types.optional(types.string, ''),
  ShippingMethodStandard: types.optional(types.string, ''),
  ShippingMethodExpress: types.optional(types.string, ''),
  ShippingMethodOvernight: types.optional(types.string, ''),
  EconomyShippingFromOutsideUS: types.optional(types.string, ''),
});

export const ShippingMethods = types
  .model('ShippingMethods', {
    internationalList: types.optional(InternationalList, {}),
    domesticList: types.optional(DomesticList, {}),
  })
  .views(self => ({
    get defaultDestination() {
      return getParent(self, 2).markets.defaultDestination;
    },
  }))
  .actions(self => ({
    fetchData: flow(function* fetchData(){
      yield Promise.allSettled([
        self.fetchInternationalList(),
        self.fetchDomesticList(),
      ])
    }),
    fetchInternationalList: flow(function* fetchInternationalList() {
      try {
        const url = `${BASE_URL}/international-shipping-methods`;
        const { data } = yield getParent(self).transport5007.fetch(url, {
          marketplaceId: self.defaultDestination.id,
        });
        self.internationalList = data;
      } catch (err) {
        console.log(err);
      }
    }),
    fetchDomesticList: flow(function* fetchDomesticList() {
      try {
        const url = `${BASE_URL}/domestic-shipping-methods`;
        const { data } = yield getParent(self).transport5007.fetch(url, {
          marketplaceId: self.defaultDestination.id,
        });
        self.domesticList = data;
      } catch (err) {
        console.log(err);
      }
    }),
  }));
